<template>
  <div>
    <div
      class="queue-cont"
      v-if="infoObj.business && infoObj.business.length > 0"
    >
      <!-- <van-tabs v-model="active" v-if="show.line1 || show.line2 || show.line3">
      <van-tab title="第一期" v-if="show.line1">
        <commonContent></commonContent>
      </van-tab>
      <van-tab title="第二期" v-if="show.line2">
        <commonContent></commonContent>
      </van-tab>
      <van-tab title="第三期" v-if="show.line3">
        <commonContent></commonContent>
      </van-tab>
    </van-tabs> -->
      <van-tabs
        v-model="active"
        v-if="show.lineListShow"
        sticky
        @change="changeTab"
      >
        <van-tab
          :title="item.name"
          v-for="(item, index) in lineList"
          :key="index"
        >
          <commonContent
            :listObj="listObj"
            :queueNumber="params.queueNumber"
            :firstList="firstList"
            :secondList="secondList"
            :socketOperaObj="socketOperaObj"
            :reportObj="infoObj"
            :isDriver="isDriver"
            :lineList="lineList"
            :active="active"
          ></commonContent>
        </van-tab>
      </van-tabs>
      <commonContent
        v-if="show.single"
        :listObj="listObj"
        :queueNumber="params.queueNumber"
        :firstList="firstList"
        :secondList="secondList"
        :socketOperaObj="socketOperaObj"
        :reportObj="infoObj"
        :isDriver="isDriver"
        :lineList="lineList"
        :active="active"
      ></commonContent>
    </div>
    <Empty
      v-if="infoObj.business && infoObj.business.length == 0"
      class="empty-div"
    ></Empty>
    <mbComSelect></mbComSelect>
  </div>
</template>
<script>
import commonContent from "./common/commonContent";
import socketListStoreMixin from "@/mixins/rh/socketListStoreMixin.js";
import socketConnetMixin from "@/mixins/rh/socketConnetMixin.js";
import Empty from "@/components/tips/Empty.vue";
import mbComSelect from "@/components/mbComSelect/index.vue";
export default {
  components: {
    Empty,
    commonContent,
    mbComSelect
  },
  data() {
    return {
      socketConnetMixinRoom: "ROOM_QUEUE", //socketConnetMixin 加入对应的房间
      active: 0,
      show: {
        line1: false,
        line2: false,
        line3: false,
        single: false,
        lineListShow: false
      },
      lineList: [], // 我的产品线信息
      infoObj: {}, // 我的报到信息对象
      listObj: {}, // 队列对象
      firstList: [], // 装货区列表
      secondList: [], // 正在排队中列表
      params: {
        businessId: "",
        queueNumber: ""
      },
      socketReturnObj: {}, // socket返回数据
      socketOperaObj: {},
      isDriver: true,
      calculationTimeInterval: null
    };
  },
  mixins: [socketConnetMixin, socketListStoreMixin],
  async mounted() {
    // this.getLine();
    // this.getQueue();
  },
  beforeRouteLeave(_to, _form, next) {
    // try {
    //   window.clearInterval(this.calculationTimeInterval);
    // } catch (error) {
    //   console.error(error);
    // }
    next();
  },
  watch: {
    async evenDriverQueueCall(val) {
      // 业务线排队状态变更
      val = JSON.parse(val);
      console.log("队列表更", val);
      let i = -1;
      this.lineList.forEach((item, index) => {
        if (item.business_id == val.business_id) {
          i = index;
        }
      });
      if (i != -1) {
        this.$set(this.lineList, i, val);
      }
    },
    async isJoinRoomAndMonitorEven(val) {
      if (val) {
        console.log("清空数据");
        console.log("获取业务数据");
        this.lineList = [];
        this.infoObj = {};
        this.listObj = {};
        this.reportObj = {};
        this.firstList = [];
        this.secondList = [];
        this.getLine();
      } else {
        console.log("socket断开");
      }
    },
    evenQueueList(val) {
      console.warn("socket数据来", evenQueue);
      const evenQueue = JSON.parse(val);
      this.changeAllList(evenQueue);

      // const evenQueue = JSON.parse(val);
      // console.warn("socket数据来", evenQueue);
      // if (JSON.stringify(val) !== "{}") {
      //   console.log(JSON.parse(String(val)));
      //   this.socketReturnObj = JSON.parse(String(val));
      //   // this.socketReturnObj.data.business_id =
      //   //   "b51980987951402a92c5e926ef741572";
      //   // this.socketReturnObj.data.info.id = "a37c1dc6e2534439b196b41df2c62ad7";
      //   if (
      //     this.socketReturnObj.data.business_id ==
      //     this.lineList[this.active].business_id
      //   ) {

      //     this.socketOperaObj = this.socketReturnObj;
      //   }
      // }
    }
    // socketOperaObj(val) {
    //   for (let i = 0; i < val.actions.length; i++) {
    //     let element = val.actions[i];
    //     if (element.queue === "QUEUE_QUEUE") {
    //       let tmpFirstList = JSON.parse(JSON.stringify(this.firstList));
    //       this.firstList = this.reSetListBySocket(
    //         element.action,
    //         val,
    //         tmpFirstList
    //       );
    //     }
    //     if (val.actions[i].queue === "QUEUE_CALLING") {
    //       let tmpSecondList = JSON.parse(JSON.stringify(this.secondList));
    //       this.firstList = this.reSetListBySocket(
    //         element.action,
    //         val,
    //         tmpSecondList
    //       );
    //     }
    //   }
    // }
  },

  methods: {
    changeAllList({ actions, data }) {
      actions.forEach(element => {
        console.log(element, data);
        // 产品线过滤
        console.log(
          "激活产品线id:" + this.lineList[this.active].business_id,
          "变更数据id：" + data.business_id
        );
        if (data.business_id != this.lineList[this.active].business_id) {
          return;
        }
        // 用于显示排队信息
        this.socketOperaObj = this.socketReturnObj;
        if (element.queue == "QUEUE_CALLING") {
          let tmpFirstList = JSON.parse(JSON.stringify(this.firstList));
          this.firstList = this.reSetListBySocket(
            element.action,
            data,
            tmpFirstList
          );
        }
        if (element.queue == "QUEUE_QUEUE") {
          let tmpSecondList = JSON.parse(JSON.stringify(this.secondList));
          this.secondList = this.reSetListBySocket(
            element.action,
            data,
            tmpSecondList
          );
        }
      });
    },
    async getLine() {
      await this.$common
        .http({
          url: "/api/queue/driver/query_report_info",
          data: {
            com_id: this.$route.query.sub_com_id
          }
        })
        .then(res => {
          console.log(res.data.data.business);
          this.infoObj = res.data.data;
          this.lineList = this.infoObj.business;
          this.isDriver = this.infoObj.is_driver;
          if (this.lineList.length === 1) {
            this.show.single = true;
          } else {
            this.show.lineListShow = true;
          }
          this.params.businessId = this.lineList[this.active].business_id;
          this.params.queueNumber = this.infoObj.business[this.active].code;
          this.getQueue();
        });
    },

    getQueue() {
      this.$common
        .http({
          url: "/api/queue/driver/query_queue",
          data: {
            business_id: this.params.businessId
          }
        })
        .then(res => {
          console.log(res);
          this.listObj = res.data.data;
          this.firstList = [];
          this.secondList = [];
          this.listObj.queue.forEach(item => {
            // 2叫号中
            console.log(item);
            if (Number(item.queue_state) === 2) {
              this.firstList.push(item);
            } else if (Number(item.queue_state) === 1) {
              // 1排队中
              this.secondList.push(item);
            }
          });
        });
    },

    changeTab(name, title) {
      console.log(name, title);
      this.params.businessId = this.lineList[name].business_id;
      this.getQueue();
    }
  },
  created() {
    console.log(this.socketConnetMixinRoom);
    // this.show.line1 = true;
    // this.show.line2 = true;
    // this.calculationTimeInterval = window.setInterval(() => {
    //   this.$common.http({
    //     url: "/api/login_test/ws_test",
    //     data: {
    //       even: "EVENT_QUEUE_REGAIN_RANK",
    //       queue_id: "73c773b78f6a4f17bdd73ffb766df671"
    //     },
    //     noLoading: true
    //   });
    // }, 10000);
  }
};
</script>
<style lang="less" scoped>
.queue-cont {
  min-height: calc(100vh - 1px);
  background: #f4f5f6;
  border-bottom: 1px solid #f4f5f6;
}
.empty-div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
